import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AdditionalOptions } from '../AdditionalOptions';
import { ServiceEx } from '../../../models/ServicePresets';
import { ExtraServicesMap, shareActionID } from '../../../constants/configuration';
import { ServiceShare } from '../../../models/Accounts';
import { getExtraServiseType } from '../../../utils';

interface ExtraservicesBlockProps {
  ServicesEx: ServiceEx[];
  Share: ServiceShare | null | undefined;
  onChangeFilms: (e: boolean, srv: ServiceEx) => void;
  onChangeDedicatedIp: (e: boolean, srv: ServiceEx) => void;
  onChangeClientService: (e: boolean, srv: ServiceEx) => void;
  isLoading: boolean;
  isExtraServicesAvailable: boolean;
}

const ExtraservicesBlock: FC<ExtraservicesBlockProps> = ({
  Share,
  onChangeFilms,
  onChangeDedicatedIp,
  onChangeClientService,
  ServicesEx,
  isLoading,
  isExtraServicesAvailable,
}) => {
  const { t } = useTranslation();

  const renderComponent = useCallback(
    (type: keyof typeof ExtraServicesMap, srv: ServiceEx) => {
      switch (type) {
        case 'client': {
          return (
            <AdditionalOptions
              key={srv.id}
              isDisabled={isLoading || !isExtraServicesAvailable}
              onChangeAdditionalService={(e) => onChangeClientService(e, srv)}
              registerFormName={`servicesExtra.${type}`}
              label={`${srv.Name} ${srv.Price} ${t('services.uahPerMonth')}`}
            />
          );
        }
        case 'dedicatedIp': {
          return (
            <AdditionalOptions
              key={srv.id}
              isDisabled={isLoading || !isExtraServicesAvailable}
              onChangeAdditionalService={(e) => onChangeDedicatedIp(e, srv)}
              registerFormName={`servicesExtra.${type}`}
              label={`${srv.Name} ${srv.Price} ${t('services.uahPerMonth')}`}
            />
          );
        }
        case 'films': {
          return (
            <AdditionalOptions
              key={srv.id}
              isDisabled={Share?.id === shareActionID || isLoading || !isExtraServicesAvailable}
              onChangeAdditionalService={(e) => onChangeFilms(e, srv)}
              registerFormName={`servicesExtra.${type}`}
              label={`${srv.Name} ${srv.Price} ${t('services.uahPerMonth')}`}
            />
          );
        }
        case 'wifiMonitoring': {
          return (
            <AdditionalOptions
              key={srv.id}
              isDisabled
              onChangeAdditionalService={() => {
                return null;
              }}
              registerFormName={`servicesExtra.${type}`}
              label={`${srv.Name} ${srv.Price} ${t('services.uahPerMonth')}`}
            />
          );
        }
        default:
          return null;
      }
    },
    [Share?.id, onChangeDedicatedIp, onChangeFilms, t],
  );

  return (
    <>
      {ServicesEx.length ? (
        <div className="payment__content__options__additional">
          {ServicesEx.map((srv) => {
            const type = getExtraServiseType(srv.Tags);
            if (!type) return null;
            return renderComponent(type, srv);
          })}
        </div>
      ) : null}
    </>
  );
};

export default ExtraservicesBlock;
